import { CurrentNetworkContext, NetworkType } from '@ms/yammer-data/dist/state/types';
import {
  UrlRootPath,
  basenameForWebApp,
  getUrlRootPath,
  networkSchemaRootPaths,
  trimBasenameFromUrlPath,
  trimLeadingAndTrailingSlash,
} from '@ms/yammer-libs-url-path-support';

type GetTenantFromPath = (urlPath: string) => boolean;
const isLegacyTenantPath: GetTenantFromPath = (urlPath) => {
  const isWebApp = urlPath.indexOf(basenameForWebApp) >= 0;
  if (!isWebApp) {
    return false;
  }

  return getUrlRootPath(urlPath) === 'other';
};

const networkTypes: Partial<Record<UrlRootPath, NetworkType>> = {
  network: 'External',
  org: 'Canonical',
};

export type GetNetworkContext = (urlPath: string) => CurrentNetworkContext;
export const getNetworkContext: GetNetworkContext = (urlPath) => {
  const urlPathWithoutBasename = trimBasenameFromUrlPath(urlPath);
  const urlPathParts = trimLeadingAndTrailingSlash(urlPathWithoutBasename).split('/');

  const isNetworkContextUrlSchema =
    urlPathParts.length >= 2 && networkSchemaRootPaths.includes(urlPathParts[0] as UrlRootPath);
  if (isNetworkContextUrlSchema) {
    const networkTypePart = urlPathParts[0] as 'org' | 'network';
    const permalink = urlPathParts[1];

    return {
      networkType: networkTypes[networkTypePart] as NetworkType,
      permalink,
      networkPath: `${networkTypePart}/${urlPathParts[1]}`,
    };
  }

  if (isLegacyTenantPath(urlPath)) {
    const tenant = urlPathParts[0];

    return {
      networkType: 'Canonical' as NetworkType,
      permalink: tenant,
      networkPath: 'org/' + tenant,
    };
  }

  return null;
};
